import type { NestedFilter } from '@@partner:graphql/types'
import type { FilterConfig } from '@components/common/filter/FilterConfig'

import React, { useCallback } from 'react'
import { Tag } from 'rsuite'
import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import {
  getSearchableProductReviewStatuses,
  prepareProductReviewFilter
} from '@@partner:helpers/productReview'

export interface ProductReviewFiltersType {
  productIds: string[]
  productXid: string[]
  statuses: number[]
}

export interface ProductReviewFilterProps {
  showIdsFilters?: boolean
  onFilterChanged: (filters: NestedFilter) => void
}

const AVAILABLE_PRODUCT_REVIEW_STATUSES = getSearchableProductReviewStatuses()

const defaultFilter: ProductReviewFiltersType = {
  productIds: [],
  productXid: [],
  statuses: []
}

const getFilterConfig = (showIdsFilters: boolean): FilterConfig[] => {
  const filters: FilterConfig[] = [
    createFilter.multiselect(
      'statuses',
      AVAILABLE_PRODUCT_REVIEW_STATUSES,
      'Статус',
      {
        searchable: false,
        renderMenuItem: (label, item) => (
          <Tag key={item?.value} color={item?.color}>
            {label}
          </Tag>
        )
      }
    )
  ]

  if (showIdsFilters) {
    filters.push(
      createFilter.multiline('productIds', 'ID товаров (по строкам)', { expandable: true, rows: 3 }),
      createFilter.multiline('productXid', 'XID товаров (по строкам)', { expandable: true, rows: 3 })
    )
  }

  return filters
}

export default function ProductReviewFilter ({
  showIdsFilters = true,
  onFilterChanged
}: ProductReviewFilterProps) {
  const handleSearch = useCallback((state: ProductReviewFiltersType) => {
    onFilterChanged(prepareProductReviewFilter(state))
  }, [ onFilterChanged ])

  const filterConfig = getFilterConfig(showIdsFilters)

  return (
    <FilterPanel<ProductReviewFiltersType>
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSearch}
    />
  )
}
